module.exports = __webpack_public_path__ + "img/hr-V-R-3-unload-standup-shadow.d2545b74.png";